module.exports = __webpack_public_path__ + "img/LP_Full_Main.4c5a58c3.svg";